import { Card, Spin, Typography } from "antd";
import FollowUpItem from "../components/Dashboard/FollowUpItem";
import { DashboardWrapper } from "../components/DashboardWrapper/DashboardWrapper.styles";
import { useFollowUps } from "../hooks/useFollowUp";
import { useNavigate } from "react-router-dom";
import { use } from "react";

const { Title, Text } = Typography;

const FollowUpPage = () => {
  const { followUps, loading } = useFollowUps();
  const navigate = useNavigate();

  return (
    <DashboardWrapper>
      <Card
        style={{
          background: "rgba(88, 80, 109, 0.30)",
          borderRadius: 16,
        }}
      >
        <Title
          level={4}
          style={{ color: "#fff", marginBottom: 24, cursor: "pointer" }}
          onClick={() => navigate(-1)}
        >
          ← All Follow-Ups
        </Title>

        {loading ? (
          <Spin />
        ) : followUps.length === 0 ? (
          <Text style={{ color: "#94a3b8" }}>No follow-ups found</Text>
        ) : (
          followUps.map((item, index) => (
            <FollowUpItem key={item.patient_id} item={item} index={index} />
          ))
        )}
      </Card>
    </DashboardWrapper>
  );
};

export default FollowUpPage;
